export default "./4fb701ba006326e351298a120baa1284.svg";